'use client';
import {useRouter} from "next/navigation";
import {useEffect, useState} from "react";
import {FontIcon, Button} from "@/app/_components";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {FirstChargeGiftPackDialogFC} from "@/app/_dialogs/FirstChargeGiftPackDialog/FirstChargeGiftPackDialog";
import {SpecialGiftPackDialogFC} from "@/app/_dialogs/SpecialGiftPackDialog/SpecialGiftPackDialog";
import {useAppSelector, useAppDispatch} from "@/app/storeHooks";
import {selectShopItems} from "@/app/(pages)/shopItemsSlice";
import {getPaymentItemsAsync} from "@/app/(pages)/paymentItemsAPI";
import {useUser} from "@/app/context/UserContext";
import UserMgr from "@/Core/UserMgr";
import styles from "./page.module.css";
import {PayRecordsDialogFC} from "@/app/(pay)/payRecords/PayRecordsDialogFC";

export default function RewardsPage() {
    const user = useUser();
    const router = useRouter();

    // 商品配置相关
    const paymentItems = useAppSelector(selectShopItems);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (UserMgr.hasTokenOk(user.token)){
            if (paymentItems.shopItemsData.length === 0) {
                dispatch(getPaymentItemsAsync())
            }
        }
    }, [user.token])

    const handleViewStarterPack = () => {
        const {shopItemsStarterData} = paymentItems;
        SDialogManagerFC.openDialog(FirstChargeGiftPackDialogFC, {
            fcKey: SDialogManagerFC.getFCKey(FirstChargeGiftPackDialogFC),
            shopItemsStarterData,
            userId: user.userId,
            dispatcher: dispatch,
        });
    }

    const handleViewSpecialPack = () => {
        const {shopItemsSpecialData} = paymentItems;
        SDialogManagerFC.openDialog(SpecialGiftPackDialogFC, {
            fcKey: SDialogManagerFC.getFCKey(SpecialGiftPackDialogFC),
            shopItemsSpecialData,
            userId: user.userId,
            dispatcher: dispatch,
        });
    }

    return (
        <div className={styles.page}>

            <div className={styles.title}>
                <FontIcon icon="s-rewards" style={{fontSize: '.8rem', color: '#EB3EFF'}}/>
                <span style={{marginLeft: '.25rem', fontSize: '.9rem', fontWeight: 400}}>REWARDS</span>
                <div className={styles.history} onClick={() => {
                    SDialogManagerFC.openDialog(PayRecordsDialogFC,{
                        fcKey:SDialogManagerFC.getFCKey(PayRecordsDialogFC),
                        onClose:(isOk:boolean)=>{
                        }
                    })
                }}>
                    <div className={styles.record_box}>
                        <FontIcon icon="s-wait2" style={{fontSize: '.55rem'}}/>
                    </div>
                </div>
            </div>

            <div className={styles.grid_container}>
                <div className={`${styles.grid_item}`}>
                    <div className={styles.grid_image}>
                        <p className={styles.grid_title}>STARTER PACK</p>
                    </div>
                    <div style={{padding: '0 .25rem'}}>
                        <Button
                            color="#33D24A"
                            size="small"
                            block
                            style={{
                                fontSize: '.6rem',
                                lineHeight: '1.1rem',
                                fontWeight: 'bold',
                            }}
                            onClick={handleViewStarterPack}
                        >
                            View
                        </Button>
                    </div>
                </div>

                <div className={`${styles.grid_item}`}>
                    <div className={styles.grid_image}>
                        <p className={styles.grid_title}>SPECIAL OFFER</p>
                    </div>
                    <div style={{padding: '0 .25rem'}}>
                        <Button
                            color="#33D24A"
                            size="small"
                            block
                            style={{
                                fontSize: '.6rem',
                                lineHeight: '1.1rem',
                                fontWeight: 'bold',
                            }}
                            onClick={handleViewSpecialPack}
                        >
                            View
                        </Button>
                    </div>
                </div>
            </div>

            <div className={styles.coming_soon}>Coming Soon</div>

        </div>
    )
}